import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../Modal/modal.css';
import apiService from "../../../utils/apiService";
import { API_URL } from '../../../utils/Constants';
import { buildDownloadApiUrl } from '../../../utils/pathUtils';


const DownloadZip = () => {

    document.body.style.backgroundImage = "none";
    document.body.style.backgroundRepeat = "no-repeat";

    const [srcUrl, setSrcUrl] = useState('');
    const location = useLocation();

    useEffect(() => {
        setSrcUrl(buildDownloadApiUrl(location.pathname, API_URL));
      }, [location.pathname])

    return(
        <div className="modal-content-table" > 

            <div id="preview_file" className='unzip-table'>
                {srcUrl && <iframe src={srcUrl} className='preview-iframe' title="Download" />}
            </div>
        </div>
    );

}

export default DownloadZip
